import React from 'react';
import './loader.scss'
export function Loader({ show, message }) {

  const showLoader = () => {
    return (
      <div className="loader-wall">
        <div className="loader">

        </div>
        <p className="loader-message">
          { message }
        </p>
      </div>

    );
  }

  return (
    show ? showLoader() : null
  )
}
